import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { downloadBuffer } from 'utils/download';

interface ValidationResult {
  valid: boolean;
  lastValidCode: string;
}

export const projectPDFLoaders = getLoaders({
  validatePDF: {
    load: async ({ code }: { code: string }): Promise<ValidationResult> => {
      return executeApiCall({
        path: '/projects/pdf/validate',

        method: 'get',

        auth: false,

        payload: {
          code,
        },
      });
    },
  },

  downloadPDF: {
    load: async ({ code }: { code: string }): Promise<void> => {
      const data = await executeApiCall<Buffer>({
        path: '/projects/pdf',

        method: 'get',

        auth: false,

        payload: {
          code,
        },

        responseType: 'arraybuffer',
      });

      downloadBuffer('offerwise-project.pdf', data);
    },
  },
});
